import { StripeElementStyle } from '@stripe/stripe-js';

export interface StripeElementsConfig {
  locale?: string;
  appearance?: StripeAppearanceConfig;
}

export interface StripeAppearanceConfig {
  theme?: 'stripe' | 'night' | 'flat';
  variables?: {
    borderRadius?: string;
    colorBackground?: string;
    colorPrimary?: string;
  };
  rules?: {
    [key: string]: any;
  };
}

export interface StripeCardStyleConfig {
  base: StripeElementStyle['base'];
  invalid?: StripeElementStyle['invalid'];
  complete?: StripeElementStyle['complete'];
}

export const DEFAULT_ELEMENT_READY_DELAY = 500;
export const STRIPE_ELEMENT_MOUNT_RETRY_ATTEMPTS = 3;
